import React, { useEffect, useRef, useState } from "react";
import CreateTopic from "../components/categoryManagement/topic/CreateTopic";
import EditTopic from "../components/categoryManagement/topic/EditTopic";
import { useDispatch } from "react-redux";
import { getTopic, topicStatusChanged } from "../features/slices/topicSlice";
import { useLocation } from "react-router-dom";
import ExportToExcel from "../components/ExportToExcel";
import { toastService } from "../utils/toastify";
import { useSelector } from "react-redux";
import moment from "moment/moment";
import TableSkeleton from "../components/TableSkeleton";
import DeleteModal from "../components/DeleteModal";
import CommonPagination from "../components/CommonPagination";
const initalState = {
  add: false,
  edit: false,
  isDeleting: false,
  page: 1,
  status: "",
  id: "",
  searchQuery: "",
};
const Topics = () => {
  const [showTopic, setShowTopic] = useState(initalState);
  const [topicData, setTopicdata] = useState("");
  const { add, edit, page, isDeleting, id, searchQuery } = showTopic;
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { loading, topics } = useSelector((state) => state.topic);
  const topicRef = useRef();
  useEffect(() => {
    dispatch(getTopic({ page, categoryId: state }));
  }, [page]);
  const handleReset = () => {
    setShowTopic(initalState);
    dispatch(getTopic({ page, categoryId: state }));
  };
  const handleStatus = (e, id) => {
    const value = e.target.checked ? "ACTIVE" : "INACTIVE";
    const data = { id: id, status: value };
    dispatch(topicStatusChanged(data)).then((data) => {
      if (data?.payload?.code === 200) {
        dispatch(getTopic({ page, categoryId: state })).then((data) => {
          if (data?.payload?.code === 200) {
            toastService.success("Status updated successfully");
            setShowTopic((prev) => ({
              ...prev,
              status: "",
            }));
          } else {
            toastService.error(data?.payload?.message);
          }
        });
      }
    });
  };
  const handleClose = () => {
    setShowTopic((prev) => ({ ...prev, isDeleting: false }));
  };
  const handleDelete = () => {
    const data = { id: id, status: "DELETED" };

    dispatch(topicStatusChanged(data)).then((data) => {
      if (data?.payload?.code === 200) {
        dispatch(getTopic({ page, categoryId: state })).then((data) => {
          if (data?.payload?.code === 200) {
            toastService.success("topic deleted successfully");
            setShowTopic((prev) => ({
              ...prev,
              status: "",
            }));
            handleClose();
          } else {
            toastService.error(data?.payload?.message);
          }
        });
      }
    });
  };
  const handleDeleteModal = (id) => {
    setShowTopic((prev) => ({ ...prev, isDeleting: true, id: id }));
  };
  const handleUpdateModal = (res) => {
    setShowTopic((prev) => ({
      ...prev,
      edit: true,
    }));
    setTopicdata(res);
  };
  const handlePageChange = (pageNumber) => {
    setShowTopic((prev) => ({
      ...prev,
      page: pageNumber,
    }));
  };
  const handleSearch = (e) => {
    const { name, value } = e.target;
    setShowTopic((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  useEffect(() => {
    if (searchQuery?.trim() !== "") {
      // Check if searchQuery is not empty
      const delayDebounceFunc = setTimeout(() => {
        dispatch(getTopic({ searchQuery, categoryId: state })).then((res) => {
          if (res?.payload?.code === 200) {
            setShowTopic((prev) => ({
              ...prev,
              searchQuery: "",
            }));
          }
        });
      }, 1000);

      return () => clearTimeout(delayDebounceFunc); // Cleanup the timeout
    }
  }, [searchQuery, dispatch, state]); // Make sure to include necessary dependencies

  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="FilterArea">
            <div className="TitleBox m-0">
              <label>&nbsp;</label>
              <a
                className="TitleLink"
                onClick={() => setShowTopic((prev) => ({ ...prev, add: true }))}
              >
                <i className="fa-solid fa-plus" /> Add New Topic
              </a>
            </div>
          </div>
          {topics?.payload?.result?.[0]?.paginationData?.length > 0 ? (
            <div className="Small-Wrapper">
              <div className="NewFilter">
                <div className="SearchBox">
                  <input
                    type="search"
                    className="SearchInput"
                    placeholder="Search by ID, Name, or Others"
                    value={searchQuery}
                    name="searchQuery"
                    onChange={(e) => handleSearch(e)}
                  />
                  <span>
                    <i className="fa fa-search" />
                  </span>
                </div>
                <div className="Actions">
                  <button className="Button Cancel ml-2" onClick={handleReset}>
                    <i className="fa fa-refresh" />
                  </button>
                  <ExportToExcel ref={topicRef} fileName="topic" />
                </div>
              </div>
              <div className="TableList">
                <table className="table-hover" ref={topicRef}>
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Topic Id</th>
                      <th>Topic Name</th>
                      <th>Created On</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <TableSkeleton />
                    ) : (
                      topics?.payload?.result?.[0]?.paginationData?.map(
                        (res, i) => {
                          return (
                            <tr key={i}>
                              {" "}
                              <td>{i + 1}</td>
                              <td>{res?.topic_number}</td>
                              <td>{res?.topicName}</td>
                              <td>
                                {moment(res?.topic_date).format("DD/MM/YYYY")}
                              </td>{" "}
                              <td>
                                <span
                                  className={
                                    res?.status === "ACTIVE" ? "Green" : "Red"
                                  }
                                >
                                  {res?.status == "ACTIVE"
                                    ? "Available"
                                    : "Blocked"}
                                </span>
                              </td>
                              <td>
                                <div className="Actions">
                                  <a
                                    className="Edit"
                                    onClick={() => handleUpdateModal(res)}
                                  >
                                    <i className="fa-regular fa-pen-to-square" />
                                  </a>
                                  <a
                                    className="Delete"
                                    onClick={() => handleDeleteModal(res?._id)}
                                  >
                                    <i className="fa-regular fa-trash-can" />
                                  </a>
                                  <label className="switch">
                                    <input
                                      type="checkbox"
                                      checked={res?.status === "ACTIVE"} // Uncomment this line if needed
                                      onChange={(e) =>
                                        handleStatus(e, res?._id)
                                      } // Uncomment and implement this function
                                    />
                                    <span className="slider" />
                                  </label>
                                </div>
                              </td>
                            </tr>
                          );
                        }
                      )
                    )}
                  </tbody>
                </table>
              </div>
              <div className="Pagination">
                <p>
                  Showing {(page - 1) * 10 + 1} to{" "}
                  {topics?.payload?.result?.[0]?.paginationData?.length +
                    (page - 1) * 10}{" "}
                  of {topics?.payload?.result?.[0]?.totalCount?.[0]?.count}{" "}
                  results
                </p>
                <div className="PaginationRight">
                  {topics?.payload?.result?.[0]?.totalCount?.[0]?.count > 0 && (
                    <CommonPagination
                      activePage={page}
                      itemsCountPerPage={10}
                      totalItemsCount={
                        topics?.payload?.result?.[0]?.totalCount?.[0]?.count ||
                        0
                      }
                      pageRangeDisplayed={4}
                      onChange={handlePageChange}
                      itemClass="page-item"
                      linkClass="page-link"
                    />
                  )}
                </div>
              </div>
            </div>
          ) : (
            <p
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "white",
                height: "200px",
                color: "green",
              }}
            >
              No Topic Yet! Please add a new topic
            </p>
          )}
        </div>
      </div>
      {add && <CreateTopic setShowTopic={setShowTopic} />}
      {edit && <EditTopic setShowTopic={setShowTopic} topicData={topicData} />}
      {isDeleting && (
        <DeleteModal
          hanldeClose={handleClose}
          handleDelete={handleDelete}
          statement={"topic"}
        />
      )}
    </>
  );
};

export default Topics;
